var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":"small","clearable":"","placeholder":"请选择","value":_vm.curValue},on:{"change":_vm.handleInput}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,style:(item.style || ''),attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }